import React from "react";

import { SignUp } from "../../../modules/signUp/components/signUp/SignUp";

export function SignUpPage() {
  return <SignUp />;
}
